<template>
  <div>
    <p>
      {{ $t('Saved Report') }}
      <a :href="'/Atlas/View/SavedReport?SavedReportID=' + notificationData.savedReportId">
        <span v-html="notificationData.name"></span>
      </a>
      {{ notificationData.updated ? $t('was updated') :  $t('was viewed') }}
    </p>
  </div>
</template>

<script>
import BaseComponent from '@/components/commentsNew/BaseComponent'

export default {
  name: 'reportUpdateNotification',
  extends: BaseComponent,
  props: {
    notificationData: {
      type: Object,
      required: true
    }
  }
}
</script>
